import productService from '../../products';
import tacHelpers from '../../../state/tac/tacHelpers';
import { translate } from '../../L10n';
import { t } from '../../../translations';
import { hasRoomSlots } from '../common';
import { ITEMS } from '../../../constants';
import _ from 'lodash';

function getWontFitMsg(product) {
  if (productService.isCabinet(product)) {
    return translate(t.CANNOT_FIT_CABINET);
  }
  if (productService.isType(product, ITEMS.DIVIDER)) {
    return translate(t.CANNOT_FIT_SHELF_DIVIDER);
  }

  return translate(t.BALLOON_HINT_NO_PLACE);
}

function couldItemFit(tac, product) {
  const fakeTac = _.cloneDeep(tac);
  const offset = productService.getSectionOffset(product);

  const tacSections = tacHelpers.getSections(tac, {});
  const nonMatchingTacSections = tacSections.filter(
    section =>
      product.filter.depth + offset.z * 2 !== section.filter.depth ||
      product.filter.width + offset.x * 2 !== section.filter.width
  );

  nonMatchingTacSections.forEach(section => {
    const matchingSection = productService.getSections(fakeTac, {
      width: product.filter.width + offset.x * 2,
      depth: product.filter.depth + offset.z * 2,
      height: section.filter.height,
    })[0];

    const newSection = tacHelpers.getSwitchableItem(section, matchingSection, {
      switchingProp: 'depth',
    });

    const replaceIndex = fakeTac.items.findIndex(
      item => item.itemid === newSection.itemid
    );

    fakeTac.items[replaceIndex] = newSection;
  });

  return !!tacHelpers.getOpenSlots(fakeTac, product).length;
}

function getDisabledStatus(tac, product, space, rebased) {
  if (productService.isInsert(product)) {
    if (!tacHelpers.hasSection(tac)) {
      return getWontFitMsg(product);
    }

    const hasOpenConnectionSlot = tacHelpers.hasOpenSlot(tac, product, rebased);

    if (
      !hasOpenConnectionSlot &&
      productService.isType(product, [ITEMS.CABINET, ITEMS.DIVIDER]) &&
      couldItemFit(tac, product)
    ) {
      return getWontFitMsg(product);
    }

    if (!hasOpenConnectionSlot) {
      return translate(t.BALLOON_HINT_NO_PLACE);
    }
  } else if (!hasRoomSlots(tac, space, product)) {
    return translate(t.BALLOON_HINT_NO_PLACE);
  }
  return false;
}

function shouldDisplayProductType(product) {
  return !productService.isSection(product);
}

function getTrashcanZoomLevel(product) {
  return productService.isAddOnShelf(product)
    ? 0.5 // looks good
    : 1.16; // default
}
const getSceneInitFunctions = () => [];

export default {
  getDisabledStatus,
  shouldDisplayProductType,
  getTrashcanZoomLevel,
  getSceneInitFunctions,
};
